export default __webpack_public_path__ + "static/media/jazzy.cc1dfc77.png";